/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/StarClub/SCCollectionGroup',['lodash'], function (_) {
    "use strict";

    var SCCollectionGroup = function (name, priority) {
        this.initSCCollectionGroup(name, priority);
    };

    SCCollectionGroup.prototype.initSCCollectionGroup = function (name, priority) {
        this.Name = name;
        this.Priority = priority;
        this.Collections = [];
    };

    SCCollectionGroup.prototype.addCollection = function (collection) {
        this.Collections.push(collection);
    };

    SCCollectionGroup.prototype.sort = function () {
        this.Collections.sort(function (a, b) {
            return a.CollectionPriority - b.CollectionPriority;
        });
    };

    SCCollectionGroup.prototype.getCollectionGroupStats = function () {
        var totalStats = {
            totalStarsEarned: 0,
            challengesCompleted: 0,
            totalChallenges: 0,
            packsUnlocked: 0,
            collectionsUnlocked: 0,
            crownsEarned: 0,
            collectionsCompleted: 0,
            collectionsTotal: 0
        };

        _.forEach(this.Collections, function (collection) {
            var stats = collection.getCollectionStats();
            totalStats.totalStarsEarned += stats.totalStarsEarned;
            totalStats.challengesCompleted += stats.challengesCompleted;
            totalStats.totalChallenges += stats.totalChallenges;
            totalStats.packsUnlocked += stats.packsUnlocked;
            totalStats.crownsEarned += stats.crownsEarned;
            totalStats.collectionsUnlocked += collection.PriceOfUnlocking > 0 && collection.Unlocked ? 1 : 0;
            totalStats.collectionsCompleted += stats.complete ? 1 : 0;
            totalStats.collectionsTotal ++;
        });

        return totalStats;
    };

    return SCCollectionGroup;
});
